<template>
  <settings-modal
    class="payment-return-modal t-payment-return-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <div
      v-if="loading"
    >
      Loading...
    </div>
    <div
      v-else
    >
      <p>
        Payment amount: {{ payment.recipientAmount | number }} {{ payment.recipientCurrency }}
      </p>
      <p>
        Amount requested: {{ paymentReturnData.amount | number }} EUR
      </p>
      <p>
        Calculated fee: {{ calculatedFeeAmount | number }} EUR
      </p>
      <p>
        Return reason: {{ paymentReturnData.reason }}
      </p>

      <v-text-field
        id="amount"
        v-model="form.amount"
        type="number"
        placeholder="0.00"
        label="Return amount"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('amount')"
      />
    </div>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        id="accept"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >return payment</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'
  import FeeApi from '@/services/Api/FeeApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  // Models
  import PaymentReturnData from '@/models/PaymentReturnData'
  import { TRANSACTION_TYPES } from '@/models/Transaction'

  // Mixins
  import form from '@/mixins/form'

  export default {
    name: 'PaymentReturnModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        fetchSepaTopupReturnData: new ApiRequest(PaymentApi.fetchSepaTopupReturnData, PaymentReturnData),
        createSepaTopupReturn: new ApiRequest(PaymentApi.createSepaTopupReturn),
        calculateTransactionFee: new ApiRequest(FeeApi.calculateTransactionalFee),
        form: { amount: null },
        requiredFields: [
          'amount'
        ]
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      },
      paymentReturnData () {
        return this.fetchSepaTopupReturnData.data
      },
      calculatedFeeAmount () {
        return this.calculatedFee != null ? this.calculatedFee.amount : 0
      },
      calculatedFee () {
        return this.calculateTransactionFee.data
      },
      heading () {
        return 'Return sepa topup'
      },
      loading () {
        return this.fetchSepaTopupReturnData.loading && this.calculateTransactionFee.loading
      },
      error () {
        return this.createSepaTopupReturn.error
      }
    },
    created () {
      this.loadPaymentReturnData()
      this.loadCalculatedFeeData()
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      loadPaymentReturnData () {
        return this.fetchSepaTopupReturnData
          .execute(this.payment.id)
          .then((payload) => {
            this.form.amount = payload.amount
          })
          .catch(() => {})
      },
      loadCalculatedFeeData () {
        return this.calculateTransactionFee
          .execute({
            currency: 'EUR',
            amount: this.payment.recipientAmount,
            direction: TRANSACTION_TYPES.OUTGOING,
            sender: this.payment.recipientAccountId,
            recipient: this.payment.senderBankAccountNumber
          })
          .catch(() => {})
      },
      onConfirmButtonClick () {
        this.createSepaTopupReturn
          .execute(this.payment.id, this.form.amount)
          .then(this.createReturnSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      createReturnSuccessHandler () {
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment return has been created.' }
          })
        }, 100)
      }
    }
  }
</script>
